export default "__VITE_ASSET__CShD0nH1__"